import { ReactNode } from 'react';

interface Prop {
  label: string;
  children: ReactNode;
}

const Tab = ({ label, children }: Prop): JSX.Element => {
  return <div id={label}>{children}</div>;
};

export default Tab;
